import { atom } from 'jotai'
import { getDanluList_aiDanluGraph_aiDanluList_edges_node } from '~/graphqls/types'

/** 是否应该更新danlu列表 */
export const scheduleListUpdateAtom = atom(false)

/** 需要更新状态的danlu id列表 */
export const pendingDanluKeyAtom = atom<string[]>([])

export const addKeyToPendingDanluKeyAtom = atom(
  null,
  (get, set, update: string) => {
    const value = Array.from(new Set([...get(pendingDanluKeyAtom), update]))
    set(pendingDanluKeyAtom, value)
  }
)

export const removeKeyFromPendingDanluKeyAtom = atom(
  null,
  (get, set, update: string) => {
    const value = get(pendingDanluKeyAtom).filter(key => key !== update)
    set(pendingDanluKeyAtom, value)
  }
)

/** buyTimeModal visible, 不为null时显示buyTimeModal */
export const buyGpuTimeForAtom = atom<{
  danluKey?: string | null
  gpuId?: string | null
} | null>(null)

/** danlu id to item */
export const danluIdMapAtom = atom<
  Record<string, getDanluList_aiDanluGraph_aiDanluList_edges_node>
>({})
